<template>
    <div>
        <input type='button' v-show="!showAddForm" class='btn btn-success' value='Добавить' @click="showAddForm=!showAddForm"/>
        <div v-show="showAddForm">
            <div class='form-group row'>
                <label class='col-form-label col-sm-2'>Наименование</label>
                <div class='col-sm-10'>
                    <input type='text' class='form-control' v-model="creat.name" />
                </div>
            </div>

            <div class='form-group row'>
                <label class='col-form-label col-sm-2'>Адрес</label>
                <div class='col-sm-10'>
                    <input type='text' class='form-control' v-model="creat.addr"/>
                </div>
            </div>

            <div class='form-group row'>
                <label class='col-form-label col-sm-2'>Сайт</label>
                <div class='col-sm-10'>
                    <input type='text' class='form-control' v-model="creat.site"/>
                </div>
            </div>

            <div class='form-group row'>
                <label class='col-form-label col-sm-2'>Контингент</label>
                <div class='col-sm-10'>
                    <input type='text' class='form-control' v-model="creat.con"/>
                </div>
            </div>

            <div class='form-group row'>
                <label class='col-form-label col-sm-2'>Выборка</label>
                <div class='col-sm-10'>
                    <input type='text' class='form-control' v-model="creat.vib"/>
                </div>
            </div>
            
            <input type='button' class='btn btn-success' value='Сохранить' @click="saveNew();" />
            <input type='button' class='btn btn-danger' value='Отменить' @click="showAddForm=!showAddForm; resetform();"/>
        </div>
        <table class='table table-bordered' v-show="!showAddForm">
            <tr>
                <th>ОО</th>
                <th>Адрес</th>
                <th>Сайт</th>
                <th>Контингент</th>
                <th>Выборка</th>
                <th>Актуализация</th>
                <th>Пароль для анкеты</th>
                <th></th>
            </tr>
            <tr v-for="data in json" :key="data.id">
                <td>{{data.name}}</td>
                <td>{{data.addr}}</td>
                <td>{{data.site}}</td>
                <td>{{data.cont}}</td>
                <td>{{data.count}}</td>
                <td>{{data.act}}</td>
                <td>{{data.pass}}</td>
                <td>
                    <input type=button class='btn btn-success' value="Редактировать" @click="updateSchool(data)" />
                    <a :href="'/foto/'+data.id" class='btn btn-info'>Фото</a>
                    <input type=button class='btn btn-danger' value="Удалить" @click="deleteSchool(data);"/>
                    <a v-if="$root.user.type==0" :href="'/eam/'+data.id" class='btn btn-info'>Анкета</a>
                    <a v-if="$root.user.type==1" :href="'/cam/'+data.id" class='btn btn-info'>Анкета</a>
                    <a class='btn btn-info' href='http://eduqa.egechita.ru/forma.pdf'>Скачать форму</a>
                    <label v-show="uploadedFoto[data.id] == undefined">Загрузить форму:</label>
                    <input v-show="uploadedFoto[data.id] == undefined" type='file' id='form' class='btn btn-info' @change="loadscanform(data.id)"/>
                    <a v-show="uploadedFoto[data.id] != undefined" :href="uploadedFoto[data.id]" class='btn btn-success' target="_blank">Скачать</a>
                    <i class="fas fa-sync" style='pointer: cursor' v-show="uploadedFoto[data.id] != undefined" @click='deleteuploadedform(data.id)'></i>
                    <a class='btn btn-info' v-show="uploadedFoto[data.id] != undefined" :href="'/schoolexpertfoto/'+data.id">Заполнить электронную форму</a>
                    <a class='btn btn-info' :href="'/back/showqr/'+data.id">QR</a>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import axios from 'axios';
import nprogress from 'nprogress';

export default {
created: function(){
    nprogress.start();
    this.getInfo();
    this.checkuploadedform();
},
methods:{
    deleteuploadedform: function(id){
        nprogress.start();
        axios({
            url: 'http://eduqa.egechita.ru/back/deleteuploadedscanform/'+id,
            withCredentials: true
        }).then(Response => {
            this.checkuploadedform();
            nprogress.done();
        });
    },
    checkuploadedform: function(){
        nprogress.start();
        axios({
            url: "http://eduqa.egechita.ru/back/getuploadedscanform",
            withCredentials: true,
        }).then(Response => {
            this.uploadedFoto = Response.data;
            nprogress.done();
        });
    },

    loadscanform: function(school){
      nprogress.start();
      var formData = new FormData();
      formData.append("file", event.target.files[0]);
      formData.append("school", school);
      axios
        .post("http://eduqa.egechita.ru/back/uploadscanform", formData, {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(Response => {
            this.checkuploadedform();
            nprogress.done();
        });
    },
    getInfo: function(){
        axios({
            url: 'http://eduqa.egechita.ru/back/schools',
          withCredentials: true
        }
        ).then((response)=>{ 
            nprogress.done();
            this.json = response.data
            })
    },
    saveNew: function(){
        if(this.creat.name == "")
        {
            alert('Необходимо заполнить имя');   
            return;
        }
        nprogress.start();
        axios({
              url: 'http://eduqa.egechita.ru/back/addschools',
              withCredentials: true,
              method: 'post',
              data: this.creat
            }).then((response) => {
                if(response.data.status == "1")
                {
                    nprogress.done();
                    this.resetform();
                    this.getInfo();
                    this.showAddForm = !this.showAddForm;
                }
            });
    },
    updateSchool: function(data){
        this.showAddForm = true;
        this.creat.name = data.name;
        this.creat.addr = data.addr;
        this.creat.site = data.site;
        this.creat.id = data.id;
        this.creat.con = data.cont;
        this.creat.vib = data.count;
    },
    resetform: function(){
        this.creat.name = "";
        this.creat.addr = "";
        this.creat.site = "";
        this.creat.id = "";
        this.creat.con = "";
        this.creat.vib = "";
    },
    deleteSchool: function(data){
        if(confirm('Действительно хотите удалить?')){
            axios({
              url: 'http://eduqa.egechita.ru/back/deleteschool/'+data.id,
              withCredentials: true
            }).then((response) => {
                if(response.data.status == "1")
                {
                    this.resetform();
                    this.getInfo();
                }
            });
        }

    }
},
    data(){
        return {
            uploadedFoto: [],
            json: "",
            showAddForm: false,
            creat:{
                name: "",
                addr: "",
                site: "",
                id: "",
                con: "",
                vib: ""
            }
        }
    }
}
</script>
